export const MIN_ZOOM = 0.25
export const MAX_ZOOM = 8
